<template>
  <div :style="{ padding: '12px', minHeight: '360px' }">
    <a-bread-crumb
      :crumbs="[{ 'path': 'resources', 'name': 'Resources'}, { 'name': `${resource.name}`}]"
    />
    <a-tabs defaultActiveKey="1" :size="size">
      <a-tab-pane tab="General" key="1">
        <a-skeleton active :loading="loading" :title="false" :paragraph="{ rows: 8, width: 800 }">
          <a-form :layout="formLayout" :form="form" style="margin-top:1em;">
            <a-text-field
              varName="name"
              varLabel="Name"
              :varRequired="true"
              :varInitial="resource.name"
              :formLayout="formLayout"
              :size="size"
            />
            <a-text-area-field
              varName="description"
              varLabel="Description"
              :varRequired="true"
              :varInitial="resource.description"
              :formLayout="formLayout"
              :size="size"
            />
            <a-url-field
              varName="endpoint"
              varLabel="Endpoint"
              :varRequired="false"
              :varInitial="resource.endpoint"
              :formLayout="formLayout"
              :size="size"
              icon="api"
              :disabled="true"
              description="A valid endpoint URL with protocol - http:// or https://."
            />
            <a-divider><mark>Provide identifier or endpoint</mark></a-divider>
            <a-slug-field
              varName="identifier"
              varLabel="Identifier"
              :varRequired="false"
              :varInitial="resource.identifier"
              :formLayout="formLayout"
              :size="size"
              :disabled="true"
              description="Containing only letters, numbers, hyphens (a valid slug)."
            />
            <a-form-item
              :wrapper-col="buttonItemLayout.wrapperCol"
              style="margin-top:0.5em; margin-left:4em;"
            >
              <a-button type="primary" shape="round" size="large" @click="handleSubmit">Update Details</a-button>
              <a-popconfirm
                v-if="!loading"
                placement="left"
                okText="Yes"
                cancelText="No"
                style="margin-left: 30px; float: right;"
                @confirm="handleDelete"
              >
                <p slot="title" style="font-size:14px;">Do you want to delete this resource？</p>
                <a-icon slot="icon" type="question-circle-o" style="color: red" />
                <a-button type="danger" size="large">Delete resource</a-button>
              </a-popconfirm>
              <a-alert v-if="error" :message="error" type="error" closable style="margin-top: 1em;" @close="onCloseError"/>
            </a-form-item>
          </a-form>
        </a-skeleton>
      </a-tab-pane>
      <a-tab-pane tab="Permissions" key="2">
        <a-scopes-tab />
      </a-tab-pane>
      <a-tab-pane tab="Clients" key="3">
        <a-clients-tab />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { formLayoutMixin } from "@/mixins/formLayout";
import AScopesTab from "@/components/Tab/AScopesTab.vue";
import AClientsTab from "@/components/Tab/AClientsTab.vue";

export default {
  data() {
    return {
      loading: true,
      size: "large",
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      error: false
    };
  },

  mixins: [formLayoutMixin],

  computed: {
    resource() {
      return this.$store.state.tenant.resources_item
        ? this.$store.state.tenant.resources_item
        : {};
    },
    options() {
      return this.$store.state.tenant.resources_options;
    }
  },

  components: {
    AScopesTab,
    AClientsTab
  },

  methods: {
    onCloseError(e) {
      console.log(e)
      this.error=false;
    },
    async handleDelete() {
      try {
        await this.$store.dispatch("tenant/deleteItem", {
          endpoint: "resources",
          uuid: this.$route.params.uuid
        });
        await this.$router.push("/resources");
        await this.$notification.open({
          message: "Resource delete!",
          description: "Resource was deleted.",
          icon: (
            <a-icon type="check-circle" theme="filled" style="color: green" />
          )
        });
      } catch (error) {
        console.error(error);
      }
    },
    handleSubmit() {
      const form = this.form;
      form.validateFields(async (err, values) => {
        if (!err) {
          try {
            if (!values['identifier'] && !values['endpoint']) {
              this.error = "You must provide an identifier or an endpoint for the resource.";
              throw new TypeError(this.error);
            }
            await this.$store.dispatch("tenant/patchItem", {
              endpoint: "resources",
              uuid: this.$route.params.uuid,
              data: values
            });
            await this.$notification.open({
                message: 'Updated!',
                description: 'Resource settings updated',
                icon: <a-icon type="check-circle" theme="filled" style="color: green" />
            });
          } catch (error) {
            console.error(error);
          }
        } else {
          console.error("Error! Check submitted values: ", values);
        }
      });
    },
    success() {
      this.$message.success("Copied.", 5);
    }
  },

  beforeCreate: async function() {
    this.form = this.$form.createForm(this);
    try {
      await this.$store.dispatch("tenant/getItem", {
        endpoint: "resources",
        uuid: this.$route.params.uuid
      });
      this.loading = false;
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  }
};
</script>